export default "__VITE_ASSET__DQE6JlEN__"